import { RootState } from "../../store";

export const isCleanDialogOpenSelector = (state: RootState): boolean =>
  !!state.clean.isOpen;
